var map = {
	"./Foods": 7611,
	"./Foods.jsx": 7611,
	"./foods.css": 9975,
	"./img/bowls/bean_veggie_taco_bowl.png": 7258,
	"./img/bowls/buckwheat_bowl.png": 2746,
	"./img/bowls/chicken_mango_bowl.png": 4370,
	"./img/bowls/dinner_bowl.png": 7176,
	"./img/bowls/fruit_nut_breakfast_bowl.png": 9420,
	"./img/bowls/matcha_breakfast_bowl.png": 190,
	"./img/bowls/morning_bowl.png": 1228,
	"./img/bowls/quick_sushi_bowl.png": 9770,
	"./img/bowls/quinoa_chicken_bowl.png": 4177,
	"./img/bowls/raspberry_bowl.png": 1606,
	"./img/bowls/red_fish_avocado_bowl.png": 5424,
	"./img/bowls/smoothie_bowl_muesli.png": 358,
	"./img/bowls/tropical_bowl.png": 2708,
	"./img/bowls/veg-packed_noodle_egg_bowl.png": 1855,
	"./img/bowls/vegetable_bowl.png": 9455,
	"./img/food_image.png": 559,
	"./img/ingredients/almond.svg": 2107,
	"./img/ingredients/almond_butter.svg": 2316,
	"./img/ingredients/almond_milk.svg": 9603,
	"./img/ingredients/almonds_toasted.svg": 417,
	"./img/ingredients/apple_cider_vinegar.svg": 437,
	"./img/ingredients/apples.svg": 1997,
	"./img/ingredients/avocado.svg": 8013,
	"./img/ingredients/baby_rocket_leaves.svg": 5776,
	"./img/ingredients/balsamic_roasted_garlic_dressing.svg": 2942,
	"./img/ingredients/balsamic_vinegar.svg": 6019,
	"./img/ingredients/banana.svg": 7325,
	"./img/ingredients/basil_leaves.svg": 1382,
	"./img/ingredients/beans.svg": 4743,
	"./img/ingredients/berries.svg": 9870,
	"./img/ingredients/black_pepper.svg": 6762,
	"./img/ingredients/black_pepper2.svg": 2420,
	"./img/ingredients/blackberries.svg": 8765,
	"./img/ingredients/blue_cheese.svg": 4790,
	"./img/ingredients/blueberries.svg": 5918,
	"./img/ingredients/broccoli.svg": 6920,
	"./img/ingredients/buckwheat.svg": 7467,
	"./img/ingredients/can_cannellini_beans.svg": 6326,
	"./img/ingredients/canned_black_beans.svg": 3254,
	"./img/ingredients/capers.svg": 4702,
	"./img/ingredients/caraway_seeds.svg": 8085,
	"./img/ingredients/carrot_juice.svg": 6878,
	"./img/ingredients/carrot_ribbons.svg": 3445,
	"./img/ingredients/cashew_nuts.svg": 2306,
	"./img/ingredients/celery.svg": 4044,
	"./img/ingredients/cherries.svg": 8769,
	"./img/ingredients/cherry.svg": 3473,
	"./img/ingredients/cherry_tomatoes.svg": 6546,
	"./img/ingredients/chia_seeds.svg": 2298,
	"./img/ingredients/chicken.svg": 4823,
	"./img/ingredients/cider_vinegar.svg": 3656,
	"./img/ingredients/cinnamon.svg": 6535,
	"./img/ingredients/coconut_flakes.svg": 1636,
	"./img/ingredients/coconut_milk.svg": 195,
	"./img/ingredients/coconut_shavings.svg": 567,
	"./img/ingredients/coconut_yogurt.svg": 8064,
	"./img/ingredients/cold_apple_juice.svg": 1832,
	"./img/ingredients/cooked_beetroot.svg": 9560,
	"./img/ingredients/cooked_brown_rice.svg": 6972,
	"./img/ingredients/coriander.svg": 8343,
	"./img/ingredients/cream.svg": 8172,
	"./img/ingredients/cucumber.svg": 1930,
	"./img/ingredients/diced_butternut_pumpkin.svg": 9318,
	"./img/ingredients/dried_medium_egg_noodles.svg": 5723,
	"./img/ingredients/fennel.svg": 9001,
	"./img/ingredients/flax_chia_seeds.svg": 9170,
	"./img/ingredients/flaxseed.svg": 3872,
	"./img/ingredients/fresh_cilantro.svg": 7403,
	"./img/ingredients/fresh_custard.svg": 4359,
	"./img/ingredients/fresh_leaves.svg": 5189,
	"./img/ingredients/garlic.svg": 6052,
	"./img/ingredients/gherkin.svg": 124,
	"./img/ingredients/ginger.svg": 1950,
	"./img/ingredients/gluten-free_beetroot.svg": 6331,
	"./img/ingredients/granola.svg": 2190,
	"./img/ingredients/grapefruit.svg": 975,
	"./img/ingredients/green_beans.svg": 3803,
	"./img/ingredients/green_bell_pepper.svg": 1344,
	"./img/ingredients/green_onion.svg": 8801,
	"./img/ingredients/green_pear.svg": 5502,
	"./img/ingredients/ground_turmeric.svg": 2997,
	"./img/ingredients/hard-boiled_egg.svg": 9577,
	"./img/ingredients/hazelnuts.svg": 6484,
	"./img/ingredients/honey.svg": 2503,
	"./img/ingredients/ice.svg": 2275,
	"./img/ingredients/jerk_paste.svg": 212,
	"./img/ingredients/kiwi.svg": 3226,
	"./img/ingredients/lemon.svg": 3459,
	"./img/ingredients/lemon_juice.svg": 1798,
	"./img/ingredients/lentils.svg": 4225,
	"./img/ingredients/lettuce.svg": 7036,
	"./img/ingredients/lime.svg": 7225,
	"./img/ingredients/lime_juice.svg": 5120,
	"./img/ingredients/mango.svg": 7116,
	"./img/ingredients/mango_chutney.svg": 967,
	"./img/ingredients/maple_syrup.svg": 1817,
	"./img/ingredients/matcha_powder.svg": 206,
	"./img/ingredients/medium_eggs.svg": 6408,
	"./img/ingredients/middle_bacon.svg": 1585,
	"./img/ingredients/milk.svg": 9563,
	"./img/ingredients/mini_savoy_cabbage.svg": 376,
	"./img/ingredients/mint_leaves.svg": 4421,
	"./img/ingredients/mozzarella.svg": 8325,
	"./img/ingredients/muesli.svg": 3273,
	"./img/ingredients/natural_yogurt.svg": 30,
	"./img/ingredients/nori.svg": 2384,
	"./img/ingredients/oat_milk.svg": 2656,
	"./img/ingredients/oats.svg": 3585,
	"./img/ingredients/olive_oil.svg": 7930,
	"./img/ingredients/onion.svg": 2461,
	"./img/ingredients/orange_juice.svg": 9641,
	"./img/ingredients/oranges.svg": 8023,
	"./img/ingredients/paprika.svg": 9538,
	"./img/ingredients/parsley_leaves.svg": 9223,
	"./img/ingredients/passion_fruit.svg": 7558,
	"./img/ingredients/peach.svg": 8729,
	"./img/ingredients/peanut_butter.svg": 7010,
	"./img/ingredients/pepitas.svg": 9214,
	"./img/ingredients/pickle.svg": 9912,
	"./img/ingredients/pickled_red_cabbage.svg": 4688,
	"./img/ingredients/pineapple.svg": 6220,
	"./img/ingredients/pineapple_juice.svg": 9849,
	"./img/ingredients/pitted_green_olives.svg": 7487,
	"./img/ingredients/pomegranate_juice.svg": 4158,
	"./img/ingredients/poppy_seeds.svg": 5829,
	"./img/ingredients/pork_loin_steak.svg": 3962,
	"./img/ingredients/porridge_oats.svg": 4214,
	"./img/ingredients/pot_raisins_nuts.svg": 2694,
	"./img/ingredients/potatoes.svg": 187,
	"./img/ingredients/pouch_stir-fry_sauce.svg": 5256,
	"./img/ingredients/prunes.svg": 9797,
	"./img/ingredients/purple_cabbage.svg": 4088,
	"./img/ingredients/radishes.svg": 5149,
	"./img/ingredients/raspberries.svg": 6388,
	"./img/ingredients/red_bell_pepper.svg": 7668,
	"./img/ingredients/red_onion.svg": 9973,
	"./img/ingredients/red_wine_vinegar.svg": 7330,
	"./img/ingredients/regular_soy_sauce.svg": 4260,
	"./img/ingredients/rice.svg": 7173,
	"./img/ingredients/rice_vinegar.svg": 7110,
	"./img/ingredients/ricotta.svg": 8220,
	"./img/ingredients/salmon.svg": 9844,
	"./img/ingredients/salt.svg": 4154,
	"./img/ingredients/sesame_oil.svg": 5237,
	"./img/ingredients/sesame_seeds.svg": 8379,
	"./img/ingredients/shaved_parmesan.svg": 8451,
	"./img/ingredients/shredded_сheddar_сheese.svg": 6755,
	"./img/ingredients/smoked_salmon.svg": 4760,
	"./img/ingredients/sour_cream.svg": 3094,
	"./img/ingredients/soy_sauce.svg": 6705,
	"./img/ingredients/spinach.svg": 3670,
	"./img/ingredients/spring_onions.svg": 4346,
	"./img/ingredients/stir-fry_vegetables.svg": 8067,
	"./img/ingredients/strawberries.svg": 1913,
	"./img/ingredients/strawberry_yogurt.svg": 1778,
	"./img/ingredients/sugar.svg": 6856,
	"./img/ingredients/teriyaki_sauce.svg": 3494,
	"./img/ingredients/thyme.svg": 7093,
	"./img/ingredients/tofu_cheese.svg": 5798,
	"./img/ingredients/tomatoes.svg": 4344,
	"./img/ingredients/unsalted_butter.svg": 5129,
	"./img/ingredients/vanilla.svg": 5695,
	"./img/ingredients/water.svg": 7204,
	"./img/ingredients/watermelon.svg": 1076,
	"./img/ingredients/white_vinegar.svg": 6350,
	"./img/ingredients/white_wine_vinegar.svg": 6768,
	"./img/ingredients/wholegrain_mustard.svg": 9335,
	"./img/logo_text.png": 9748,
	"./img/salads/avocado_salad.png": 1171,
	"./img/salads/basic_chicken_salad.png": 1450,
	"./img/salads/caprese.png": 2573,
	"./img/salads/classic_potato.png": 4942,
	"./img/salads/easy_caprese_bean.png": 1619,
	"./img/salads/grilled_lettuce_almonds.png": 267,
	"./img/salads/orange_fennel_salad.png": 5213,
	"./img/salads/pork_radish_rocket.png": 1785,
	"./img/salads/pumpkin_beetroot.png": 9179,
	"./img/salads/salmon_salad.png": 2304,
	"./img/salads/smoked_salmon_avocado.png": 5830,
	"./img/salads/strawberry_spinach_salad.png": 3832,
	"./img/salads/tomato_olive.png": 8650,
	"./img/salads/watermelon_blueberry.png": 9471,
	"./img/salads/white_slaw_dressing.png": 6243,
	"./img/smoothies/banana_smoothie.png": 9409,
	"./img/smoothies/berry_smoothie.png": 5964,
	"./img/smoothies/blackberry_smoothie.png": 7349,
	"./img/smoothies/blueberry_banana_smoothie.png": 1808,
	"./img/smoothies/cherry_smoothie.png": 5453,
	"./img/smoothies/coconut_banana_smoothie.png": 5681,
	"./img/smoothies/green_smoothie.png": 1895,
	"./img/smoothies/kiwi_smoothie.png": 9864,
	"./img/smoothies/peach_smoothie.png": 57,
	"./img/smoothies/peanut_butter_smoothie.png": 9812,
	"./img/smoothies/raspberry_apple_smoothie.png": 9393,
	"./img/smoothies/strawberry_green_smoothie.png": 4133,
	"./img/smoothies/strawberry_smoothie.png": 8073,
	"./img/smoothies/sunshine_smoothie.png": 4825,
	"./img/smoothies/watermelon_smoothie.png": 3698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7348;